/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import { useState } from 'react';
import clsx from 'clsx';
import { UseFormRegisterReturn } from 'react-hook-form';
import { AppFieldWrapper, FieldWrapperPassThroughProps } from './AppFieldWrapper';
import {FaEye, FaEyeSlash} from "react-icons/fa6";
import React from 'react';

type InputFieldProps = FieldWrapperPassThroughProps & {
    type?: 'text' | 'email' | 'password' | 'date';
    min?: string;
    label: string;
    className?: string;
    descriptor?: string;
    descriptorClass?: string;
    registration: Partial<UseFormRegisterReturn>;
    disabled?: boolean;
    tooltip?: any;
};

export const AppInput = (props: InputFieldProps) => {
    const { type = 'text', label, className, registration, descriptor, descriptorClass, disabled, error, min } = props;

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const isPasswordField = type === 'password';
    const inputType = isPasswordField && showPassword ? 'text' : type;

    return (
        <AppFieldWrapper error={error}>
            <div className="relative">
                <input
                    min={min}
                    autoCapitalize={'off'}
                    placeholder={label}
                    type={inputType}
                    className={clsx(
                        'mt-4 flex h-16 w-full items-center text-base justify-center rounded-sm border border-black bg-white/30 p-3 outline-hidden dark:text-mono-0 dark:border-mono-0 dark:bg-mono-600',
                        disabled && "border-none! bg-gray-100! dark:bg-white/5! dark:placeholder:text-[rgba(255,255,255,0.15)]!",
                        className
                    )}
                    {...registration}
                />
                {descriptor && (
                    <div className={`${descriptorClass ? descriptorClass : `absolute top-[4px] left-1 px-2 rounded-sm text-base bg-background-base-0 flex items-center py-4`}`}>{descriptor}</div>
                )}
                {isPasswordField && (
                    <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 dark:text-gray-300 hover:scale-105 transition-transform ease-in-out duration-300"
                        aria-label={showPassword ? 'Hide password' : 'Show password'}
                    >
                        {showPassword ? <FaEyeSlash className="text-xl text-mono-1000"/> : <FaEye className="text-xl text-mono-1000"/>}
                    </button>
                )}
            </div>
        </AppFieldWrapper>
    );
};

